export enum ReservationStatus {
  Quote = 10,
  BookedPending = 20,
  BookedComplete = 30,
  CancelPending = 40,
  CancelComplete = 50,
  BookBalanceDue = 60
}